import { canRead, canWrite } from '../access/rbacAccess'

export const SEGMENTS = {
  LIST: 'planifica.segments'
}

export const canViewSegments = () => canRead(SEGMENTS.LIST)

export const canManageSegments = () => canWrite(SEGMENTS.LIST)
